import { render, staticRenderFns } from "./kvkk.vue?vue&type=template&id=8dc91896&scoped=true&"
import script from "./kvkk.vue?vue&type=script&lang=js&"
export * from "./kvkk.vue?vue&type=script&lang=js&"
import style0 from "./kvkk.vue?vue&type=style&index=0&id=8dc91896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc91896",
  null
  
)

export default component.exports